import script from "./AListMonths.vue?vue&type=script&setup=true&lang=js"
export * from "./AListMonths.vue?vue&type=script&setup=true&lang=js"

import "./AListMonths.vue?vue&type=style&index=0&id=b83063c6&lang=css"

const __exports__ = script;

export default __exports__